import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticlePage from "../pages/article/page";
import CSSBuyGuidePage from "../pages/cssbuy-guide/page";
import SuperbuyGuidePage from "../pages/superbuy-guide/page";
import OopbuyGuidePage from "../pages/oopbuy-guide/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/kakobuy-spreadsheet-guide",
    element: <ArticlePage />,
  },
  {
    path: "/cssbuy-spreadsheet-guide",
    element: <CSSBuyGuidePage />,
  },
  {
    path: "/superbuy-spreadsheet-guide",
    element: <SuperbuyGuidePage />,
  },
  {
    path: "/oopbuy-spreadsheet-guide",
    element: <OopbuyGuidePage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;